import { useEffect, useState } from "react";

import BgbTaproot from "./Applications/src-bgb-taproot/App";
import Taproot from "./Applications/src-taproot/App";
import SiteExit from "./Applications/src-site-exit/App";
import ComingSoon from "./Applications/ComingSoon";

import axiosConfig from "./Utils/axiosConfig";

const mapTemplateStringOrId = (val) => {
  const s = String(val || "")
    .toLowerCase()
    .trim();

  if (
    s === "1" ||
    s === "convientional" ||
    s === "conventional" ||
    s === "temp1" ||
    s === "temp1-key"
  ) {
    return "temp1";
  }

  if (
    s === "2" ||
    s === "temp2" ||
    s === "temp2-key"
  ) {
    return "temp2";
  }

  if (
  s === "3" ||
  s === "construction" ||
  s === "construction-key"
) {
  return "construction";
}

  return s;
};

function App() {

  const [templateData, setTemplateData] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {

    async function getData() {
      try {
        let res;
        try {
          res = await axiosConfig.get("/sitedata/site-config/");
        } catch (err) {
          console.warn("site-config failed, falling back to site API", err);
          res = await axiosConfig.get("/sitedata/site/");
        }

        let siteData = null;
        let templateName = "";

        if (res?.data?.site) {
          siteData = res.data.site;

          if (res.data.selected_template) {
            templateName = res.data.selected_template;
          } else if (res.data.template && typeof res.data.template === "object") {
            templateName = 
              res.data.template.key || 
              res.data.template.code || 
              res.data.template.template_name || 
              res.data.template.template_code;
          } else if (res.data.site?.template?.template_name) {
            templateName = res.data.site.template.template_name;
          } else if (res.data.template) {
            templateName = res.data.template;
          }
        } else if (res?.data?.results?.[0]) {
          siteData = res.data.results[0];
          templateName =
            siteData?.template?.frontend_key ||
            siteData?.template?.key ||
            siteData?.template?.template_code ||
            "";
        }
 
        if (siteData) {
          localStorage.setItem("site_data", JSON.stringify(siteData));
          if (!templateName) {
            if (siteData.title) {
              document.title = siteData.title;
            }
            
            let link = document.querySelector("link[rel~='icon']");
            if (!link) {
              link = document.createElement('link');
              link.rel = 'icon';
              document.head.appendChild(link);
            }
            if (siteData.favicon?.image) {
              link.href = siteData.favicon.image;
            } else {
              link.href = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="50" cy="50" r="50" fill="gray"/></svg>';
            }
          }
        }

        setTemplateData(mapTemplateStringOrId(templateName));

      } catch (error) {
        console.log("Error fetching site data:", error);
      } finally {
        setIsLoading(false);
      }
    }

    getData();

  }, []);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  switch (templateData?.toLowerCase()) {

    case "temp1":
      return (
        <div className="template-temp1">
          <Taproot />
        </div>
      );

    case "temp2":
      return (
        <div className="template-temp2">
          <BgbTaproot />
        </div>
      );

    case "construction":
      return (
        <div className="template-construction">
          <SiteExit />
        </div>
      );

    default:
      return (
        <div className="template-temp1">
          <ComingSoon />
        </div>
      );
  }
}

export default App;